export default __webpack_public_path__ + "static/media/ic-present.7dadaf49.svg";